import * as React from "react";
import { withDefault } from "collection-utils";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";

import {
    Wrapper,
    HeadingWrapper,
    Heading,
    Desc,
    ButtonRow,
    ActionBar,
    Input,
    Info,
} from "../modal-provider/modal-provider-style";
import { styled } from "sharedUI/styles";
import { getNamedIcon } from "common/named-icons";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";

interface Props {
    header: React.ReactNode;
    description: React.ReactNode;
    showWarning?: boolean;
    checkboxText?: string;
    cancelText?: string;
    acceptText?: string;
    destroyText?: string;

    informationText?: string;
    entryHeader?: string;

    informationAction?: () => void;
    informationActionClosesModal?: boolean;
    acceptAction?: (checkboxState: boolean) => void;
    acceptActionClosesModal?: boolean;
    cancelAction?: (checkboxState: boolean) => void;
    destroyAction?: (checkboxState: boolean) => void;

    acceptDisabled?: boolean;
    modals: SimpleModalContextProps;
}

interface State {
    readonly checked: boolean;
}

const ModalWrapper = styled(Wrapper)`
    color: ${p => p.theme.fgColorDark};
    padding: 20px 20px;
`;

class ActionModal extends React.Component<Props, State> {
    public state: State = { checked: false };

    public render(): React.ReactNode {
        const {
            header,
            description,
            showWarning,
            acceptText,
            acceptAction,
            acceptActionClosesModal,
            destroyText,
            destroyAction,
            informationText,
            informationAction,
            informationActionClosesModal,
            cancelText,
            cancelAction,
            checkboxText,
            acceptDisabled,
        } = this.props;

        let buttonRow: React.ReactNode | undefined;
        let cancelcb: (() => void) | undefined;
        if (acceptText !== undefined || destroyText !== undefined) {
            let acceptButton: React.ReactNode;
            let destroyButton: React.ReactNode;
            let cancelButton: React.ReactNode;
            let checkboxButton: React.ReactNode;

            if (checkboxText !== undefined) {
                checkboxButton = (
                    <Input>
                        <input
                            type="checkbox"
                            name="opt out"
                            checked={this.state.checked}
                            onChange={event => this.setState({ checked: event.target.checked })}
                        />
                        <p>{checkboxText}</p>
                    </Input>
                );
            }

            if (cancelText !== undefined || cancelAction !== undefined) {
                cancelcb = () => {
                    if (cancelAction !== undefined) {
                        cancelAction(this.state.checked);
                    }
                    this.props.modals.DEPRECATED_removeAllModals();
                };

                cancelButton = (
                    <ButtonVNext
                        onClick={cancelcb}
                        buttonType={"secondary"}
                        variant={"default"}
                        size={"md"}
                        label={withDefault(cancelText, "Cancel")}
                    />
                );
            }
            if (acceptText !== undefined) {
                acceptButton = (
                    <ButtonVNext
                        disabled={acceptDisabled}
                        onClick={() => {
                            if (acceptAction !== undefined) {
                                acceptAction(this.state.checked);
                            }
                            if (acceptAction === undefined || withDefault(acceptActionClosesModal, true)) {
                                this.props.modals.DEPRECATED_removeAllModals();
                            }
                        }}
                        buttonType={"primary"}
                        variant={"default"}
                        size={"md"}
                        label={acceptText}
                    />
                );
            }
            if (destroyText !== undefined) {
                destroyButton = (
                    <ButtonVNext
                        onClick={() => {
                            if (destroyAction !== undefined) {
                                destroyAction(this.state.checked);
                            }
                            this.props.modals.DEPRECATED_removeAllModals();
                        }}
                        buttonType={"primary"}
                        variant={"danger"}
                        size={"md"}
                        label={destroyText}
                    />
                );
            }

            buttonRow = (
                <ButtonRow>
                    {checkboxButton}
                    {cancelButton}
                    {destroyButton}
                    {acceptButton}
                </ButtonRow>
            );
        }

        let infoLabel: React.ReactNode | undefined;
        if (informationText !== undefined) {
            infoLabel = (
                <Info
                    onClick={() => {
                        if (informationAction !== undefined) {
                            informationAction();
                        }
                        if (informationAction === undefined || withDefault(informationActionClosesModal, true)) {
                            this.props.modals.DEPRECATED_removeAllModals();
                        }
                    }}>
                    {informationText}
                </Info>
            );
        }

        const handleKeyPress = (ev: React.KeyboardEvent<HTMLDivElement>) => {
            if (ev.key === "Escape") {
                cancelcb?.();
                ev.stopPropagation();
            }
        };

        const WarningIcon = getNamedIcon("warning");
        return (
            <ModalWrapper onKeyDown={handleKeyPress}>
                <HeadingWrapper>
                    {showWarning && <WarningIcon />}
                    <Heading>{header}</Heading>
                </HeadingWrapper>
                <Desc>{description}</Desc>
                <ActionBar>
                    {infoLabel}
                    {buttonRow}
                </ActionBar>
            </ModalWrapper>
        );
    }
}

export default withModalProvider(ActionModal);
